export function formatDisplayDate(value?: Date | string | null): string {
  if (!value) return 'TBD';
  if (typeof value === 'string') {
    const normalized = value.replace(/\//g, '-');
    const ddmm = /^(\d{2})-(\d{2})-(\d{4})$/;
    const iso = /^(\d{4})-(\d{2})-(\d{2})/;
    if (ddmm.test(normalized)) return normalized.slice(0, 10);
    const match = normalized.match(iso);
    if (match) return `${match[3]}-${match[2]}-${match[1]}`;
  }
  const date = new Date(value as string | Date);
  if (Number.isNaN(date.getTime())) return 'TBD';
  return [date.getDate(), date.getMonth() + 1, date.getFullYear()]
    .map((part, index) => index < 2 ? String(part).padStart(2, '0') : String(part))
    .join('-');
}

export function parseAppointment(input: string): { appointmentDate: string | null; appointmentTime: string | null } {
  const trimmed = input.trim();
  if (!trimmed) return { appointmentDate: null, appointmentTime: null };
  const match = trimmed.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})(?:\s+(.+))?$/);
  if (!match) return { appointmentDate: trimmed, appointmentTime: null };
  const day = match[1].padStart(2, '0');
  const month = match[2].padStart(2, '0');
  const year = match[3];
  return { appointmentDate: `${day}-${month}-${year}`, appointmentTime: match[4]?.trim() || null };
}

export function inspectionTimestamp(date?: string | Date | null, time?: string | null): number {
  if (!date) return Number.POSITIVE_INFINITY;
  const displayDate = formatDisplayDate(date);
  const dateMatch = displayDate.match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!dateMatch) return Number.POSITIVE_INFINITY;
  let minutes = 0;
  if (time) {
    const timeMatch = time.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);
    if (timeMatch) {
      let hours = Number(timeMatch[1]);
      const minutePart = Number(timeMatch[2]);
      const meridiem = timeMatch[3]?.toUpperCase();
      if (meridiem === 'PM' && hours !== 12) hours += 12;
      if (meridiem === 'AM' && hours === 12) hours = 0;
      minutes = hours * 60 + minutePart;
    }
  }
  const dayStamp = new Date(Number(dateMatch[3]), Number(dateMatch[2]) - 1, Number(dateMatch[1])).getTime();
  return dayStamp + minutes * 60_000;
}

export function timestampLabel(prefix = 'Photo'): string {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  return `${prefix} ${dd}-${mm}-${yyyy} ${hh}:${min}`;
}
